import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
interface AccordionItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
}
export function AccordionItem({
  question,
  answer,
  isOpen,
  onToggle
}: AccordionItemProps) {
  return <div className="border-b border-stone-200 last:border-b-0" data-id="element-633" data-mp="2oaj9r440cul1">
      <button onClick={onToggle} className="w-full flex items-center justify-between py-4 text-left focus:outline-none group" data-id="element-634" data-mp="2ob2s2lxklkzl">
        <span className="text-base sm:text-lg font-bold text-forest-700 group-hover:text-forest-600 transition-colors pr-4" data-id="element-635" data-mp="3h000zyfw65fo">
          {question}
        </span>
        <span className={`flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center transition-colors ${isOpen ? 'bg-forest-600 text-white' : 'bg-stone-100 text-stone-500 group-hover:bg-stone-200'}`} data-id="element-636" data-mp="3368z9c8ejpui">
          {isOpen ? <Minus className="w-4 h-4" data-id="element-637" data-mp="3llppzp2v2hk" /> : <Plus className="w-4 h-4" data-id="element-638" data-mp="31x9t2fxz6drw" />}
        </span>
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100 pb-4' : 'max-h-0 opacity-0'}`} data-id="element-639" data-mp="31v75e2kaowqc">
        <p className="text-stone-600 leading-relaxed" data-id="element-640" data-mp="3bo4p2c10wrqj">{answer}</p>
      </div>
    </div>;
}
interface AccordionProps {
  items: {
    q: string;
    a: string;
  }[];
}
export function Accordion({
  items
}: AccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <div className="bg-white p-6 sm:p-8 rounded-2xl shadow-sm border border-stone-200" data-id="element-641" data-mp="3gmxwpntmpois">
      {items.map((item, idx) => <AccordionItem key={idx} question={item.q} answer={item.a} isOpen={openIndex === idx} onToggle={() => setOpenIndex(openIndex === idx ? null : idx)} data-id="element-642" data-mp="3ulfel4wus6ss" data-mpi={idx} />)}
    </div>;
}